<div *ngIf="displayMaxSavedCartErrorMsg">
  <vs-custom-global-msg ></vs-custom-global-msg>
  </div>

<div *ngIf="currentCart" class="saved-cart-summary">
  <table>
    <tr>
      <th colspan="2" class="heading">
        <div *ngIf = "!sharedTextFlag">
          <span *ngIf ="!quoteTextFlag">{{ "savedCart.savedCarts" | cxTranslate }}</span>
          <span *ngIf ="quoteTextFlag">{{ "savedCart.quoteSavedCarts" | cxTranslate }}</span> 
          - {{ currentCart.code }}  {{ "savedCart.details" | cxTranslate }}
        </div> 
        <div *ngIf = "sharedTextFlag">
          <span *ngIf ="!quoteTextFlag">{{ "savedCart.sharedCarts" | cxTranslate }}</span>
          <span *ngIf ="quoteTextFlag">{{ "savedCart.quoteSharedCarts" | cxTranslate }}</span>
          - {{ currentCart.code }} {{ "savedCart.details" | cxTranslate }}
        </div>
      </th>
      <th colspan="2" class="actions-column">
        <a
          (click)="extendExpiry(currentCart)"
          matTooltipClass="vs-tooltip capitalize"
          matTooltip='{{ "savedCart.extendTooltipTxt" | cxTranslate }}'
          ><i class="icons extend"></i
        ></a>
        <a
          matTooltipClass="vs-tooltip capitalize"
          matTooltip='{{ "savedCart.downloadTooltipTxt" | cxTranslate }}'
          (click)="downloadSaveCart()"
          ><i class="icons download"></i
        ></a>
        <a
          (click)="restoreSavedCart(currentCart)"
          matTooltipClass="vs-tooltip capitalize"
          matTooltip='{{ "savedCart.restoreTooltipTxt" | cxTranslate }}'
          ><i class="icons restore"></i
        ></a>
        <a
          class="delete-icon"
          (click)="deleteSavedCart(currentCart)"
          matTooltipClass="vs-tooltip capitalize"
          matTooltip='{{ "savedCart.deleteTooltipTxt" | cxTranslate }}'
          ><i class="material-icons delete">delete</i></a
        >
      </th>
    </tr>
    <tr>
      <td>
        <div class="label">{{ "savedCart.cartName" | cxTranslate }}</div>
        <div class="value">{{ currentCart.name }}</div>
      </td>
      <td>
        <div class="label">{{ "savedCart.id" | cxTranslate }}</div>
        <div class="value">{{ currentCart.code }}</div>
      </td>
      <td>
        <div *ngIf = "!sharedTextFlag">
          <div class="label">{{ "savedCart.totalLine" | cxTranslate }}</div>
          <div class="value">{{ currentCart.totalItems }}</div>
        </div> 
        <div *ngIf = "sharedTextFlag">
          <div class="label">{{ "savedCart.createdBy" | cxTranslate }}</div>
          <div class="value">{{ currentCart.savedBy.name }}</div>
        </div>
      </td>
      <td>
        <div class="label">
          {{ "savedCart.estimatedTotal" | cxTranslate }}
          <i
            class="material-icons info"
            matTooltipClass="vs-tooltip"
            matTooltip='{{ "savedCart.priceChangeTooltipTxt" | cxTranslate }}'
            >info</i
          >
        </div>
        <div class="value">
          {{ currentCart.totalPriceWithTax.currencyIso }}
          {{ currentCart.totalPriceWithTax.formattedValue }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="label">{{ "savedCart.dataSave" | cxTranslate }}</div>
        <div class="value">
          {{ currentCart.saveTime | date: "dd MMM yyyy" }}
        </div>
      </td>
      <td>
        <div class="label">{{ "savedCart.expiryDate" | cxTranslate }}</div>
        <div class="value">
          {{ currentCart.expirationTime | date: "dd MMM yyyy" }}
          <!-- <span *ngIf="currentCart.showWarning"><em
            class="material-icons warning"
            *ngIf="isExpiring(currentCart.expirationTime, currentCart.savedCartDaysToExpire)"
            matTooltipClass="vs-tooltip"
            matTooltip="Your Saved Cart is about to expire."
            >{{ "savedCart.warning" | cxTranslate }}</em
          ></span> -->

          <span *ngIf="currentCart.displayExpiryWarning"><em
            class="material-icons warning"
            *ngIf="currentCart.displayExpiryWarning"
            matTooltipClass="vs-tooltip"
            matTooltip='{{ "savedCart.cartExpiredTooltipTxt" | cxTranslate }}'
            >warning</em
          ></span>

        </div>
      </td>
      <td colspan="2">
        <div class="label">{{ "savedCart.description" | cxTranslate }}</div>
        <div class="value">{{ currentCart.description }}</div>
      </td>
    </tr>
  </table>
</div>

<div class="saved-cart-products tb-parent">
  <mat-table #table [dataSource]="dataSource">
    <ng-container matColumnDef="index">
      <mat-header-cell *matHeaderCellDef class="tb-heading index-column">
        #
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tb-content index-column">{{
        element.index
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="product">
      <mat-header-cell *matHeaderCellDef class="tb-heading product-column tb-heading-product"
        >{{ "savedCart.product" | cxTranslate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element" class="tb-content product-column">
        <div class="product-image">
          <a
                [routerLink]="
                  {
                    cxRoute: 'product',
                    params: element.product
                  } | cxUrl
                "
                ><cx-media
                class="category-missing-img category-img"
                *ngIf="!element.url?.url"
                [container]="apiurl + element.url?.url"
              ></cx-media></a
              >
          
        </div>
        <div class="product-info">
          <div class="code">
            <div class="label">{{ "savedCart.partModelNumber" | cxTranslate }}</div>
            <div class="value">
              <a
                [routerLink]="
                  {
                    cxRoute: 'product',
                    params: element.product
                  } | cxUrl
                "
                >{{ element.product.code }}</a
              >
            </div>
          </div>
          <div class="name">
            <div class="label">{{ "savedCart.partDescription" | cxTranslate }}</div>
            <div class="value">{{ element.product.name }}</div>
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <mat-header-cell *matHeaderCellDef class="tb-heading quantity-column"
        >{{ "savedCart.quantity" | cxTranslate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element" class="tb-content quantity-column">{{
        element.quantity
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="price">
      <mat-header-cell *matHeaderCellDef class="tb-heading price-column"
        >{{ "savedCart.price" | cxTranslate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element" class="tb-content price-column">
        {{ element.netPrice.currencyIso }}
        {{ element.netPrice.formattedValue }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="total">
      <mat-header-cell *matHeaderCellDef class="tb-heading total-column"
        >{{ "savedCart.total" | cxTranslate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element" class="tb-content total-column">
        {{ element.totalPrice.currencyIso }}
        {{ element.totalPrice.formattedValue }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let element; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
